import { getApi } from "../client/apiClient";
import type { HttpClient } from "../client/types";
import type { PaginatedResponse } from "../client/types/common.types";
import type {
  CreateBuildingRequest,
  GetBuildingsRequest,
  Building,
  UpdateBuildingRequest,
  GetBuildingsCountResponse,
  GetBuildingsCountRequest,
} from "../client/types/building.types";

const createBuildingEndpoints = (client: HttpClient = getApi()) => ({
  getBuildings: async (
    params?: GetBuildingsRequest
  ): Promise<PaginatedResponse<Building>> => {
    const { data: response } = await client.get<PaginatedResponse<Building>>(
      "/buildings",
      { params }
    );
    return response;
  },
  getBuildingById: async (id: string): Promise<Building> => {
    const { data: response } = await client.get<Building>(`/buildings/${id}`);
    return response;
  },
  createBuilding: async (data: CreateBuildingRequest): Promise<Building> => {
    const { data: response } = await client.post<Building>("/buildings", data);
    return response;
  },
  updateBuilding: async (
    id: string,
    data: UpdateBuildingRequest
  ): Promise<Building> => {
    const { data: response } = await client.put<Building>(
      `/buildings/${id}`,
      data
    );
    return response;
  },
  getBuildingsCount: async (params?: GetBuildingsCountRequest): Promise<GetBuildingsCountResponse> => {
    const { data: response } = await client.get<GetBuildingsCountResponse>("/buildings/count/total", { params });
    return response;
  },
});

export type BuildingEndpoints = ReturnType<typeof createBuildingEndpoints>;

export const buildingEndpoints = createBuildingEndpoints();

